export const DEFAULT_DPI = '300'
